module.exports = __webpack_public_path__ + "iq.svg?58949f0e715f2f6c05cd8b4d9234f9e2";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/iq.svg
// module id = 1282
// module chunks = 27